import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./ProviderApp.scss";
import { Modal } from "react-bootstrap";
import CloseBtn from "assets/icons/Close-1.svg";
import ProviderAppIcon from "assets/icons/providerApp.svg";

function PopUpModal() {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    localStorage.setItem("download-provider:seen", true);
    setShow(false);
  };

  let navigate = useNavigate();
  const routeChange = () => {
    localStorage.setItem("download-provider:seen", true);
    setShow(false);
    let path = `eb/download-provider`;
    navigate(path);
  };

  return (
    <div>
      <Modal
        className="modal-overlay pop-up-modal"
        size="l"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header className="p-0">
          <button
            type="button"
            className="close close-button position-relative pb-0"
            onClick={handleClose}
          >
            <img src={CloseBtn} alt="modal-close" className="w-30" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <img
                src={ProviderAppIcon}
                alt="provider-app-icon"
                className="center"
              />
            </div>
            <div className="title">Never miss a patient request!</div>
            <div className="description">
              If you wish to receive timely patient requests, we recommend
              downloading the <span className="red">BD4Providers</span> app and
              enabling notifications.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="flex-column button-footer">
          <button
            className="btn btn-link download-button"
            onClick={routeChange}
          >
            <>Download Now</>
          </button>
          <button
            className={"btn btn-link later-button"}
            type="submit"
            onClick={() => handleClose()}
          >
            <>Maybe Later</>
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PopUpModal;
